// Testing environment configuration.
// Use this file for testing builds by configuring fileReplacements in angular.json.

export const environment = {
  production: true,
  serverURL: 'https://qa.api.travsta.com',
  version: "1.1.4.0",
  chargebeeSite: 'purple-software-test',
  posthogKey: "phc_qeVfH0v6PCP7Qlv6crU9THXcvWBEe9Hh0Sk0oZvT5eF",
  posthogHost: "https://us.i.posthog.com",
  allowedAnalyticsHosts: ['app.travsta.com'],
  previewLink: 'https://qa.preview.travsta.com',
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
